(function() {
  const M64Waitlist = {
    elements: {
      shareButtons: document.querySelectorAll('.m64-waitlist__share-btn')
    },
    
    shareTitle: 'Check out the M64 colors!',
    
    init() {
      this.bindEvents();
    },
    
    bindEvents() {
      this.elements.shareButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const platform = e.currentTarget.dataset.platform;
          this.share(platform);
        });
      });
    },
    
    share(platform) {
      // URL already reflects current color selection
      const currentUrl = window.location.href;
      
      const url = encodeURIComponent(currentUrl);
      const title = encodeURIComponent(this.shareTitle);
      
      const shareUrls = {
        x: `https://twitter.com/intent/tweet?url=${url}&text=${title}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        bluesky: `https://bsky.app/intent/compose?text=${title}%20${url}`,
        whatsapp: `https://wa.me/?text=${title}%20${currentUrl}`,
        email: `mailto:?subject=${title}&body=${url}`
      };
      
      const platformUrl = shareUrls[platform];
      
      if (platform === 'email') {
        const link = document.createElement('a');
        link.href = platformUrl;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open(platformUrl, '_blank', 'width=600,height=400');
      }
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => M64Waitlist.init());
  } else {
    M64Waitlist.init();
  }
})();